import api from '../../../config/axios-interceptor';

const buildStartDateParams = (startDate) => {
    if (!startDate) return {};
    return { startDate };
};

/* --------------------------
 * 1) Open Chats
 * -------------------------- */
export const getOperatorOpenChats = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/operator/dashboard/open-chats', { params });
    } catch (error) {
        console.error('❌ Error fetching operator open chats:', error);
        throw error;
    }
};

/* --------------------------
 * 2) Average Rating
 * -------------------------- */
export const getOperatorAverageRating = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/operator/dashboard/average-rating', { params });
    } catch (error) {
        console.error('❌ Error fetching operator average rating:', error);
        throw error;
    }
};

/* --------------------------
 * 3) Average Wait Time
 * -------------------------- */
export const getOperatorAverageWaitTime = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/operator/dashboard/average-wait-time', { params });
    } catch (error) {
        console.error('❌ Error fetching operator average wait time:', error);
        throw error;
    }
};

/* --------------------------
 * 4) Unread Chats
 * -------------------------- */
export const getOperatorUnreadChats = async () => {
    try {
        return await api.get('/api/v1/operator/dashboard/unread-chats');
    } catch (error) {
        console.error('❌ Error fetching operator unread chats:', error);
        throw error;
    }
};

/* --------------------------
 * 5) Active Chats
 * -------------------------- */
export const getOperatorActiveChats = async () => {
    try {
        return await api.get('/api/v1/operator/dashboard/active-chats');
    } catch (error) {
        console.error('❌ Error fetching operator active chats:', error);
        throw error;
    }
};

/* --------------------------
 * 6) Resolved Chats
 * -------------------------- */
export const getOperatorResolvedChats = async (startDate) => {
    try {
        const params = buildStartDateParams(startDate);
        return await api.get('/api/v1/operator/dashboard/resolved-chats', { params });
    } catch (error) {
        console.error('❌ Error fetching resolved chats:', error);
        throw error;
    }
};